// extracted by mini-css-extract-plugin
export default {"errorPage":"Error_errorPage__Bq97c","errorWrapper":"Error_errorWrapper__KdDi4","errorContainer":"Error_errorContainer__0IhnF"};